import style from 'styled-components';

export const StyledFlotaBigItem = style.div`

    .flota-car-img, .car-item {
        @media only screen and (min-width: ${props => props.theme.screens.xl}){
            width: 50%;
            max-width: 50%;
            flex: 50%;
        }
    }

    .flota-car-img.one-slide {
        @media only screen and (min-width: ${props => props.theme.screens.xl}){
            width: 70%;
            flex: 70%;
        }
        .car-image {
            border: none!important;
            margin: 0 auto;
            padding: 0px;
        }
    }

    .car-image{
        border: solid 1px #C8C8C8;
        margin: 0 4%;
        padding: 4% 10%;

        @media only screen and (max-width: ${props => props.theme.screens.md}){
            margin-left: 0;
            margin-right: 0;
        }
    }

    p{
        font-size: 12px;
        margin-bottom: 1rem;
    }

    .price span{
        font-weight: bold;
    }

    .price strong{
        font-size: 22px;
    }

    h2.car-name{
        font-size: 24px;
        font-weight: 700;
        margin-bottom: 5px;
        text-transform: uppercase;
        
        @media only screen and (max-width: ${props => props.theme.screens.md}){
            font-size: 16px;
        }
    }

    .car-category{
        font-weight: 600;
    }

    .car-description {
        color: #6f6f6f;
        margin-bottom: 30px;
        font-size: 12px;
    }

    .details{
        margin-bottom: 12px;
    }

    .car-item .details-item {
        display: inline-block;
        text-align: center;
        margin-right:5px;
        width: 10.5%;
        max-width: 37px;
        
        img{
            width: 100%;
            display: block;
            border: 1px solid #CCCCCC;
            padding: 5px;
            border-radius: 7px;
            margin-bottom: 5px;
        }
    }

    .price p{
        font-size: 16px;
    }

    button{
        width:auto;
    }
`;
